import { call, put } from 'redux-saga/effects';

import { GET_CREDIT_REVIEW_CONTRACT_DATA } from 'store/creditReview/creditReviewActions';
import { addNotificationAction } from 'store/notifications/notificationsActions';

import {
  fetchProducts,
  changeProductsFavoriteStatus,
  fetchShopHistory,
  addProductsToBasket,
  removeProductsFromBasket,
  fetchProductProperties,
  startFreeTrial,
  startFreeSubscription,
  fetchShopPermissions,
} from '../services';
import {
  FETCH_SHOP_PRODUCTS_SUCCESS,
  FETCH_SHOP_PRODUCTS_ERROR,
  CHANGE_SHOP_PRODUCTS_FAVORITE_STATUS_SUCCESS,
  CHANGE_SHOP_PRODUCTS_FAVORITE_STATUS_ERROR,
  FETCH_SHOP_HISTORY_SUCCESS,
  FETCH_SHOP_HISTORY_ERROR,
  ADD_SHOP_PRODUCTS_TO_BASKET_SUCCESS,
  ADD_SHOP_PRODUCTS_TO_BASKET_ERROR,
  REMOVE_SHOP_PRODUCTS_FROM_BASKET_SUCCESS,
  REMOVE_SHOP_PRODUCTS_FROM_BASKET_ERROR,
  FETCH_SHOP_PRODUCT_PROPERTIES_SUCCESS,
  FETCH_SHOP_PRODUCT_PROPERTIES_ERROR,
  START_SHOP_PRODUCT_FREE_TRIAL_ERROR,
  START_SHOP_PRODUCT_FREE_TRIAL_SUCCESS,
  START_SHOP_PRODUCT_FREE_SUBSCRIPTION_SUCCESS,
  START_SHOP_PRODUCT_FREE_SUBSCRIPTION_ERROR,
  FETCH_SHOP_PERMISSIONS_SUCCESS,
  FETCH_SHOP_HISTORY,
} from './shopActions';

export function* fetchShopProductsSaga() {
  try {
    const response = yield call(fetchProducts);
    yield put({ type: FETCH_SHOP_PRODUCTS_SUCCESS, payload: { products: response } });
  } catch (response) {
    yield put({ type: FETCH_SHOP_PRODUCTS_ERROR, payload: response });
  }
}

export function* changeShopProductsFavoriteStatusSaga({ payload }) {
  try {
    yield call(changeProductsFavoriteStatus, payload);
    yield put({ type: CHANGE_SHOP_PRODUCTS_FAVORITE_STATUS_SUCCESS, payload });
  } catch (response) {
    yield put({ type: CHANGE_SHOP_PRODUCTS_FAVORITE_STATUS_ERROR });
    throw new Error(response);
  }
}

export function* fetchShopHistorySaga() {
  try {
    const response = yield call(fetchShopHistory);
    yield put({ type: FETCH_SHOP_HISTORY_SUCCESS, payload: { history: response.data } });
  } catch (response) {
    yield put({ type: FETCH_SHOP_HISTORY_ERROR, payload: response });
  }
}

export function* addShopProductsToBasketSaga({ payload }) {
  try {
    yield call(addProductsToBasket, payload);
    yield put({ type: ADD_SHOP_PRODUCTS_TO_BASKET_SUCCESS, payload });
  } catch (response) {
    yield put({ type: ADD_SHOP_PRODUCTS_TO_BASKET_ERROR });
    throw new Error(response);
  }
}

export function* removeShopProductsFromBasketSaga({ payload }) {
  try {
    yield call(removeProductsFromBasket, payload);
    yield put({ type: REMOVE_SHOP_PRODUCTS_FROM_BASKET_SUCCESS, payload });
  } catch (response) {
    yield put({ type: REMOVE_SHOP_PRODUCTS_FROM_BASKET_ERROR });
    throw new Error(response);
  }
}

export function* fetchShopProductsPropertiesSaga() {
  try {
    const response = yield call(fetchProductProperties);
    yield put({
      type: FETCH_SHOP_PRODUCT_PROPERTIES_SUCCESS,
      payload: { properties: response.data },
    });
  } catch (response) {
    yield put({ type: FETCH_SHOP_PRODUCT_PROPERTIES_ERROR, payload: response });
  }
}

export function* startShopProductFreeTrialSaga({ payload }) {
  try {
    yield call(startFreeTrial, { products: [payload.id] });
    yield put({ type: START_SHOP_PRODUCT_FREE_TRIAL_SUCCESS, payload });
    yield put(
      addNotificationAction({
        message: 'Free trial successfully started.',
        variant: 'success',
      }),
    );
    yield put({ type: FETCH_SHOP_HISTORY });

    // FIXME: Make sure that it only runs for products related to Credit Review.
    // At the moment it is possible only to detect this by product id, but it would
    // require a predefined list of products which would have to be updated when
    // new product is introduced.
    yield put({ type: GET_CREDIT_REVIEW_CONTRACT_DATA });
  } catch (response) {
    yield put({ type: START_SHOP_PRODUCT_FREE_TRIAL_ERROR });
    yield put(
      addNotificationAction({
        message: 'Error starting free trial.',
        variant: 'error',
      }),
    );
    throw new Error(response);
  }
}

export function* startShopProductFreeSubscriptionSaga({ payload }) {
  try {
    yield call(startFreeSubscription, { products: [payload.id] });
    yield put({ type: START_SHOP_PRODUCT_FREE_SUBSCRIPTION_SUCCESS, payload });
    yield put(
      addNotificationAction({
        message: 'Free subscription successfully started.',
        variant: 'success',
      }),
    );
    yield put({ type: FETCH_SHOP_HISTORY });
  } catch (response) {
    yield put({ type: START_SHOP_PRODUCT_FREE_SUBSCRIPTION_ERROR });
    yield put(
      addNotificationAction({
        message: 'Error starting free subscription.',
        variant: 'error',
      }),
    );
    throw new Error(response);
  }
}

export function* fetchShopPermissionsSaga() {
  try {
    const response = yield call(fetchShopPermissions);

    yield put({
      type: FETCH_SHOP_PERMISSIONS_SUCCESS,
      payload: response,
    });
  } catch (response) {
    yield put({ type: FETCH_SHOP_PRODUCTS_ERROR, payload: response });
  }
}
